import { JobStatusType, ScheduleTimeBasedPattern } from "@/enum"
import { DAYS_OF_WEEK_TRIGGER_TYPES } from "../constants"
import type { IJobScheduleOptions } from "@/interfaces"
import { ValueBasedTriggerType } from "@/enum/ValueBasedTriggerType"
import moment from "moment"

export const getRecurringLabel = (scheduleOptions: any, repeatAfterEvery: number | null, pattern: ScheduleTimeBasedPattern) => {
  const repeatAfterEveryLabel = repeatAfterEvery ? repeatAfterEvery : null
  let labelString = ''

  if (repeatAfterEveryLabel === null) {
    labelString = 'At what intervals should it repeat?'
    return labelString
  }

  switch (pattern) {
    case ScheduleTimeBasedPattern.DAYS: {
      labelString = repeatAfterEveryLabel === 1 ? 'Repeats everyday' : `Repeat every ${repeatAfterEveryLabel} days`
    }
    break
    case ScheduleTimeBasedPattern.WEEKS: {
      labelString = repeatAfterEveryLabel === 1 ? 'Repeats every week' : `Repeat every ${repeatAfterEveryLabel} weeks`
    }
    break
    case ScheduleTimeBasedPattern.MONTHS: {
      labelString = repeatAfterEveryLabel === 1 ? 'Repeats every month' : `Repeat every ${repeatAfterEveryLabel} months`
    }
    break
    case ScheduleTimeBasedPattern.YEARS: {
      labelString = repeatAfterEveryLabel === 1 ? 'Repeats every year' : `Repeat every ${repeatAfterEveryLabel} years`
    }
    break
    default:
      return ''
  }

  if (ScheduleTimeBasedPattern.WEEKS === pattern) {
    if (scheduleOptions.timeBasedTrigger.daysOfWeek?.length > 0) {
      if (scheduleOptions.timeBasedTrigger.daysOfWeek.length === 7) {
          labelString += ' on all days';
      } else if (scheduleOptions.timeBasedTrigger.daysOfWeek.length === 1) {
          labelString += ` on ${DAYS_OF_WEEK_TRIGGER_TYPES.find(d => d.value === scheduleOptions.timeBasedTrigger.daysOfWeek[0])?.title}`;
      } else if (scheduleOptions.timeBasedTrigger.daysOfWeek.length === 2) {
          labelString += ` on ${scheduleOptions.timeBasedTrigger.daysOfWeek.map((day: any) => 
              DAYS_OF_WEEK_TRIGGER_TYPES.find(d => d.value === day)?.title
          ).join(' and ')}`;
      } else {
          labelString += ` on ${scheduleOptions.timeBasedTrigger.daysOfWeek.map((day: any, index: number) => {
              if (index === scheduleOptions.timeBasedTrigger.daysOfWeek.length - 1) {
                  return `and ${DAYS_OF_WEEK_TRIGGER_TYPES.find(d => d.value === day)?.title}`;
              } else {
                  return `${DAYS_OF_WEEK_TRIGGER_TYPES.find(d => d.value === day)?.title}, `;
              }
          }).join('')}`;
      }
    } else if (scheduleOptions.timeBasedTrigger.daysOfWeek?.length == 0) {
      labelString = 'Please select days of the week from above'
    }
  }

  return labelString
}

export const valudBasedTriggerTypes = [
  { value: ValueBasedTriggerType.AtValue, title: 'At' },
  { value: ValueBasedTriggerType.IncrementByValue, title: 'In' }
]

export const getDueStatusText = (job: any) => {
  const { scheduledAt, dueAt, status } = job;

  if (!dueAt) {
    return 'N/A';
  }

  const dueDate = moment(dueAt);
  const today = moment().startOf('day');

  if (dueDate.isBefore(today, 'day') && status !== JobStatusType.COMPLETED) {
    return 'Overdue';
  }

  if (dueDate.isSame(today, 'day')) {
    return 'Today';
  }

  if (dueDate.isAfter(today, 'day')) {
    return 'Upcoming';
  }

  return 'N/A';
}
